<template>
    <div
        :class="[
            'custom-input',
            { active: isActive },
            { 'has-error': validationError },
        ]"
        :label-text="placeholder"
        ref="wrapper"
        :style="`width: ${width}`"
    >
        <input
            autocomplete="new-password"
            :class="[
                { capitalize: capitalize },
                { 'has-error': validationError },
            ]"
            ref="field"
            :type="type"
            :required="required"
            @focus="activated"
            @blur="checkLabel"
            @input="validateInput"
            :tabindex="tabindex"
            v-model="value"
            :name="name"
            :placeholder="placeholder"
            v-bind="$attrs"
            v-on="$listeners"
            @keydown.space.prevent
        />

        <p v-if="type == 'password'" @click="toggleMask">
            <i class="mdi mdi-eye-off" ref="eye"></i>
        </p>
        <div
            :class="['validation-error', { 'show-error': validationError }]"
            v-if="!noError"
        >
            {{ messageError }}
        </div>
    </div>
</template>
<script>
import patterns from "@/validations/patterns";

export default {
    props: {
        name: {
            type: String,
        },
        placeholder: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
        width: {
            type: String,
            default: "100%",
        },
        tabindex: {
            type: Number,
            default: 0,
        },
        capitalize: {
            type: Boolean,
            default: false,
        },
        validate: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        noError: {
            type: Boolean,
            default: false,
        },
        rule: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: "",
        },
        currValue: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            value: "",
            validationError: false,
            messageError: "",
            isActive: false,
        };
    },
    watch: {
        currValue: {
            immediate: true,
            handler(val) {
                this.value = val;
            },
        },
    },
    methods: {
        activated() {
            this.isActive = true;
        },
        checkLabel() {
            if (this.value == "") {
                if (this.required) {
                    this.validationError = true;
                    this.messageError = this.$t("Please add a valid info");
                }
            } else if (this.validate == "") {
                this.validationError = false;
            }
        },
        toggleMask() {
            let eye = this.$refs.eye;
            let input = this.$refs.field;
            if (eye.classList.contains("mdi-eye")) {
                eye.classList.remove("mdi-eye");
                eye.classList.add("mdi-eye-off");
                input.setAttribute("type", "password");
            } else {
                eye.classList.add("mdi-eye");
                eye.classList.remove("mdi-eye-off");
                input.setAttribute("type", "text");
            }
        },
        validateInput() {
            if (
                "٠١٢٣٤٥٦٧٨٩".includes(this.value.slice(-1)) &&
                this.value != ""
            ) {
                this.value = "";
                this.validationError = true;
                this.$buefy.toast.open({
                    message: this.$t(
                        "You are typing arabic number, please type english number"
                    ),
                    type: "is-primary",
                });
            }
            if (this.validate == "") {
                this.$emit("value", this.value);
            } else {
                if (this.value == "") {
                    this.validationError = false;
                } else {
                    let p,
                        m = "";
                    if (this.validate == "custom") {
                        p = new RegExp(`^${this.rule}$`);
                        m = this.message;
                    } else if (this.validate == "text-input") {
                        this.value = this.value.replace(/[^A-Za-z]/gi, "");
                    } else if (this.validate == "number-input") {
                        this.value = this.value.replace(/[^0-9]/g, "");
                    } else if (this.validate == "address-input") {
                        this.value = this.value.replace(
                            /[^0-9a-zA-Z|^.|^#|^,]/gi,
                            ""
                        );
                    } else {
                        p = patterns[`${this.validate}`];
                        m = patterns.errors[`${this.validate}`];
                    }
                    if (this.value.match(p)) {
                        this.validationError = false;
                        this.$emit("value", this.value);
                    } else {
                        this.validationError = true;
                        this.messageError = m;
                    }
                }
            }
        },
        check() {
            this.validateInput();
            this.checkLabel();
            return this.validationError;
        },
    },
};
</script>
<style lang="scss" scoped>
$primary: #ffcb04;
$error: #eb6174;
input {
    background-color: #f6f6ff;
    line-height: 30px;

    &:enabled {
        outline: none !important;
    }
}

.custom-input {
    position: relative;
    display: inline-block;

    // &::before {
    //     content: "";
    //     position: absolute;
    //     display: block;
    //     left: 0;
    //     top: 100%;
    //     width: 100%;
    //     height: 1px;
    //     background: $primary;
    //     z-index: 5;
    //     transform: scaleX(0);
    //     transform-origin: left;
    //     transition: 0.4s linear;
    // }

    // &::after {
    //     content: "";
    //     position: absolute;
    //     display: block;
    //     left: 0;
    //     top: 100%;
    //     width: 100%;
    //     height: 1px;
    //     background: $error;
    //     z-index: 8;
    //     transform: scaleX(0);
    //     transform-origin: left;
    //     transition: 0.4s linear;
    // }

    &.active::before {
        transform: scaleX(1);
    }

    &.has-error::after {
        transform: scaleX(1);
    }

    p {
        position: absolute;
        display: block;
        top: -5px;
        right: 0;
        font-size: 1.4em;
        margin-right: 15px;
        margin-top: 5px;
        cursor: pointer;
    }

    input {
        width: 100%;
        border-radius: 5px;
        padding: 5px 10px 2px;
        color: #444444;
        font-size: 1em;
        font-weight: 500;
        transition: 0.25s ease-out;
        display: inline-block;
        direction: ltr;
        &:lang(ar) {
            text-align: right;
            &::placeholder {
                direction: rtl;
            }
        }
    }

    .validation-error {
        transition: 0.25s ease-in-out;
        color: #eb6174 !important;
        position: absolute;
        font-size: 13px;
        top: calc(100% + 2px);
        left: 5px;
        visibility: hidden;
    }

    .validation-error.show-error {
        visibility: visible !important;
    }
}
</style>
